import type { C1_Opening } from "../model/C1_Opening";
import type { C1_EloItem_Definition } from "../types/C1_EloTypes";
import { C1_EloItem_Type } from "../types/C1_EloTypes";
import type { DoorType } from "../types/C1_ModelTypes";
import { getEloItemProfile } from "./C1_eloItemsRegistry";

export type C1_OpeningEloProfile = {
  rootDefinitionId: string;
  definitions: C1_EloItem_Definition[];
};

const doorProfileIds: Record<DoorType, string> = {
  interior: "door-internal",
  passage: "door-passage",
  entrance: "door-entrance",
  garden: "door-garden",
};

export function getOpeningEloProfile(opening: C1_Opening): C1_OpeningEloProfile {
  if (opening.kind === "garage-door") {
    const rootDefinitionId = "garage-door";
    return { rootDefinitionId, definitions: getEloItemProfile(rootDefinitionId) };
  }
  if (opening.kind === "door") {
    const rootDefinitionId = doorProfileIds[opening.doorType] ?? doorProfileIds.entrance;
    const definitions = getEloItemProfile(rootDefinitionId);
    if (opening.doorType !== "garden") return { rootDefinitionId, definitions };

    const shadingDefinitions =
      opening.windowShading === "none"
        ? []
        : getEloItemProfile(`window-${opening.windowShading}`).filter(
            (definition) => definition.type === C1_EloItem_Type.Blind || definition.type === C1_EloItem_Type.Jalousie,
          );
    return {
      rootDefinitionId,
      definitions: [
        ...definitions.filter(
          (definition) => definition.type !== C1_EloItem_Type.Blind && definition.type !== C1_EloItem_Type.Jalousie,
        ),
        ...shadingDefinitions,
      ],
    };
  }

  const rootDefinitionId = `window-${opening.windowShading}`;
  return {
    rootDefinitionId,
    definitions: getEloItemProfile(rootDefinitionId),
  };
}
